import {dataTestId} from '@hconnect/uikit'
import {Check} from '@mui/icons-material'
import {Button, Tooltip} from '@mui/material'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {usePlantConfig} from '../../../shared/hooks/usePlantConfigData'
import {getLocalizedDayMonthTimeFormat} from '../../../shared/selectors/time'
import {OptimizerScheduleType} from '../shared/enums/optimizerSchedules'

import {OptimizerSchedule} from './hooks/useOptimizerPlansOverview'

interface OptimizerPlanAcceptanceInfoProps {
  schedule: OptimizerSchedule
}

export const OptimizerPlanAcceptanceInfo: React.FC<OptimizerPlanAcceptanceInfoProps> = ({
  schedule
}) => {
  const {timezone_id: timezoneId} = usePlantConfig()
  const {
    t,
    i18n: {language}
  } = useTranslation()

  if (schedule.type !== OptimizerScheduleType.Optimized || !schedule.isLatestAcceptedSchedule) {
    return null
  }

  const {
    lastSaved: {savedAt, savedBy}
  } = schedule

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: (theme) => theme.spacing(50)
          }
        }
      }}
      title={t('optimizer.acceptedPlanTooltip', {
        acceptedBy: savedBy,
        acceptedOn: getLocalizedDayMonthTimeFormat(moment.utc(savedAt), timezoneId, language)
      })}
      {...dataTestId('optimized_plan_acceptance_info')}
    >
      <Button
        color="success"
        variant="text"
        startIcon={<Check {...dataTestId('accepted_icon')} />}
        sx={{p: 0, '&:hover': {background: 'none'}}}
      >
        {t('optimizer.accepted')}
      </Button>
    </Tooltip>
  )
}
